import { type Account, Provider } from '@repo/api-gw-sdk';
import semver from 'semver';

export const extractRoleArn = (roleArn: string) => {
  const roleParts = roleArn.split(/:|\//).reverse();
  const role = roleParts[0];
  const accountId = roleParts[2];
  return { role, accountId };
};

const providerSupportsVersioning = (provider: Provider) =>
  provider === Provider.Aws || provider === Provider.Gcp;

export const isAccountRoleOld = (account: Account) => {
  return (
    providerSupportsVersioning(account.cloudProvider) &&
    !!account.latestVersion &&
    semver.lt(account.installedVersion ?? '1.0.0', account.latestVersion)
  );
};

export const isAccountRoleMajorMinorVersionOld = (account: Account) => {
  return (
    providerSupportsVersioning(account.cloudProvider) &&
    !!account.latestVersion &&
    isMajorMinorLess(account.installedVersion ?? '1.0.0', account.latestVersion)
  );
};

function isMajorMinorLess(a: string, b: string) {
  const normalized = (v: string) => `${semver.major(v)}.${semver.minor(v)}.0`;
  return semver.lt(normalized(a), normalized(b));
}

export const isAccountFeatureSupported = (
  featureVersion: string,
  account: Account
): boolean => {
  return Boolean(isFeatureSupported(featureVersion, account.installedVersion));
};

const isFeatureSupported = (
  featureVersion: string,
  installedVersion?: string
) => {
  return (
    installedVersion &&
    semver.valid(installedVersion) &&
    semver.gte(installedVersion, featureVersion)
  );
};
